import { useIsMobile } from '#src/assets/hooks/useIsMobile.ts'
import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { ActionBar } from '#src/assets/ui/shared/components/ActionBar.tsx'
import { Button } from '#src/assets/ui/shared/components/Button.tsx'
import { buttonFullWidthStyle, uiTokens } from '#src/assets/ui/shared/styles.ts'

export function CookieConsentActions({
  onAcceptAll,
  onRejectAll,
  onManagePreferences,
  t,
}: {
  onAcceptAll: () => void
  onRejectAll: () => void
  onManagePreferences: () => void
  t: CookieConsentTranslator
}) {
  const isMobile = useIsMobile()

  return (
    <ActionBar
      isMobile={isMobile}
      padding="0.75rem 1.5rem 1rem"
      gap="0.5rem"
      leftGap="0.5rem"
      left={
        <>
          <Button
            variant="primary"
            style={isMobile ? buttonFullWidthStyle : undefined}
            onClick={event => {
              event.stopPropagation()
              onAcceptAll()
            }}
          >
            {t('acceptAllBtn')}
          </Button>
          <Button
            variant="primary"
            hoverBackground={uiTokens.colors.gray900}
            hoverColor={uiTokens.colors.white}
            style={isMobile ? buttonFullWidthStyle : undefined}
            onClick={event => {
              event.stopPropagation()
              onRejectAll()
            }}
          >
            {t('acceptNecessaryBtn')}
          </Button>
        </>
      }
      right={
        <Button
          variant="secondary"
          style={isMobile ? buttonFullWidthStyle : undefined}
          onClick={event => {
            event.stopPropagation()
            onManagePreferences()
          }}
        >
          {t('showPreferencesBtn')}
        </Button>
      }
    />
  )
}
